import $ from 'jquery';
window.$ = window.jQuery = $;

// import 'jquery-ui/ui/widgets/';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);
import 'slick-slider/slick/slick'
import 'slick-slider/slick/slick.css'

import LocomotiveScroll from 'locomotive-scroll';
import imagesLoaded from 'imagesloaded';
// import AOS from 'aos';
const windowWidth =  window.innerWidth;
    $(window).on('load', function(){
        setTimeout(removeLoader, 2900);
    });
    function removeLoader(){
        $( ".preloader" ).css("transform", "translateY(-100%)");
    }
    $(function(){
        var calcWidth = 0;
        $('.post-slider-item').each(function(index, el){
            calcWidth += $(el).width();
        })

        // console.log(calcWidth);
        //
        // $('.pin-wrap').css('width', calcWidth + 500 + 'px');

        var $headerH = $( '.masthead' ).outerHeight();
        setTimeout(function(){
            $('.hero h1:not(.sub-hero h1)').addClass('is-loaded');
        }, 3400)
        $('.sub-hero h1').addClass('is-loaded');
        // AOS.init({
        //     duration: 1000, // values from 0 to 3000, with step 50ms
        //     easing: 'ease', // default easing for AOS animations
        // });
        const pageContainer = document.querySelector('[data-scroll-container]');

        // Initialize the Locomotive scroll
        const scroll = new LocomotiveScroll({
            el: document.querySelector('[data-scroll-container]'),
            smooth: true
        });

        if(windowWidth > 767 && $('.pin-wrap')[0]){

            console.log('here');

            var scroller = scroll

            scroller.on("scroll", ScrollTrigger.update);

            ScrollTrigger.scrollerProxy('[data-scroll-container]', {
                scrollTop(value) {
                    return arguments.length
                        ? scroller.scrollTo(value, 0, 0)
                        : scroller.scroll.instance.scroll.y;
                },
                getBoundingClientRect() {
                    return {
                        left: 0,
                        top: 0,
                        width: windowWidth,
                        height: window.innerHeight
                    };
                },
                pinType: pageContainer.style.transform ? "transform" : "fixed"
            });

            let pinBoxes = document.querySelectorAll(".pin-wrap > *");
            let pinWrap = document.querySelector(".pin-wrap");
            let pinWrapWidth = pinWrap.offsetWidth;
            let horizontalScrollLength = pinWrapWidth - windowWidth;

            console.log(pinWrapWidth);
            console.log(windowWidth);
            // Pinning and horizontal scrolling

            gsap.to(".pin-wrap", {
                scrollTrigger: {
                    scroller: "[data-scroll-container]",
                    scrub: true,
                    trigger: "#sectionPin",
                    pin: true,
                    // anticipatePin: 1,
                    start: "top top",
                    end: pinWrapWidth,

                },
                x: -horizontalScrollLength,
                ease: "none"
            });

            ScrollTrigger.addEventListener("refresh", () => scroller.update());

            ScrollTrigger.refresh();
        }


        // scroll.on('call', (func, args, obj) => {
        //     var $menuItem = $('a[href="#' + $(obj.el).attr('data-menu-target') + '"]');
        //     console.log(func);
        //
        //     if(args == 'enter'){
        //         if(func == 'updateWhatwedo'){
        //             $('#menu-main-menu a').removeClass('underline-text');
        //             $('a[href="#whatwedo').addClass('underline-text');
        //         }
        //
        //         if(func == 'updateWhyblockliving'){
        //             $('#menu-main-menu a').removeClass('underline-text');
        //             $('a[href="#whyblockliving').addClass('underline-text');
        //         }
        //
        //         if(func == 'updateFaqs'){
        //             $('#menu-main-menu a').removeClass('underline-text');
        //             $('a[href="#FAQs').addClass('underline-text');
        //         }
        //
        //         if(func == 'updateEthos'){
        //             $('#menu-main-menu a').removeClass('underline-text');
        //             $('a[href="#ourethos').addClass('underline-text');
        //         }
        //
        //     }
        //     // if(args !== 'enter'){
        //     //     $menuItem.removeClass('underline-text');
        //     // }
        //
        //     // console.log(func);
        //     console.log(args);
        //     // console.log(obj.id);
        // });


        $('.js-popup').on('click', function(){
            $('body').addClass('is-open');
        });

        $('.js-close-popup').on('click', function(){
            $('body').removeClass('is-open');
        });
        var $singleClick = 0;
        $('.accordion-item a').on('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            // $('.accordion-content').slideUp();
            // $('.accordion-close').hide();
            // $('.accordion-open').show();

            $(this).find('.accordion-content').slideToggle();
            $(this).find('.accordion-open').toggle();
            $(this).find('.accordion-close').toggle();

            setTimeout(function(){
                scroll.update();
            }, 1200);


        })

        $('body').on('keyup', 'input', function(e){
            $(this).parent().parent().removeClass('gfield_error');
            $(this).parent().parent().find('.validation_message').hide();
            $('.gform_validation_errors').hide();

        });

        $('body').on("click", ".number-button", function(e) {
            e.preventDefault();
            var $button = $(this);
            var oldValue = $button.parent().find("input").val();

            if ($button.hasClass('inc')) {
                var newVal = parseFloat(oldValue) + 1;
            } else {
                // Don't allow decrementing below zero
                if (oldValue > 0) {
                    var newVal = parseFloat(oldValue) - 1;
                } else {
                    newVal = 0;
                }
            }

            $('#input_2_5').val(newVal);

            $button.parent().find("input").val(newVal);

        });


        $('#gform_1').on('submit', function(){
            $('.popup h2').hide();
        })

        $('.number-input-wrapper input').on('change', function(){
            $('#input_2_5').val($(this).val());
        })



        // Select all links with hashes
        $('a[href*="#"]')
            // Remove links that don't actually link to anything
            .not('[href="#"]')
            .not('[href="#0"]')
            .click(function(event) {
                // On-page links
                if (
                    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                    &&
                    location.hostname == this.hostname
                ) {
                    // Figure out element to scroll to
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    // Does a scroll target exist?
                    if (target.length) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        $('.masthead__nav ul a').removeClass('bolder');
                        $(this).addClass('bolder')
                        var $postion = target.position()
                        scroll.scrollTo( $postion.top, {
                            'offset': -$headerH + 'px',
                            'callback': function() {
                                // do something...
                            },
                            'duration': 600,
                            'easing': [0.25, 0.00, 0.35, 1.00],
                            'disableLerp': true
                        } );
                    }
                }
            });

        $(window).on('resize', function(){
          setTimeout(function(){
              scroll.update();
          }, 400)
        });

        $('.quote-slider-init').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            autoplay: true,
            autoplaySpeed: 6000,
            dots: false,
            arrows: false

        });

        $('.single-slider-init').each(function(index,el){

            var blockID = $(el).attr('id');

            $(el).slick({
                infinite: false,
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: $('.' + blockID +  '-arrow-prev'),
                nextArrow: $('.' + blockID +  '-arrow-next'),
            })
        })

        var singleblockID = $('.slider-init').attr('id');



        $('.slider-init').each(function(index, el){
            var blockID = $(el).attr('id');
            $(el).slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 2,
                slidesToScroll: 1,
                cssEase: 'linear',
                rtl: true,
                prevArrow: $('.' + blockID +  '-arrow-prev'),
                nextArrow: $('.' + blockID +  '-arrow-next'),
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,

                        }
                    },
                    {
                        breakpoint: 540,
                        settings: {
                            slidesToShow: 1,
                        }
                    }

                ]
            });
        })


        // $('.post-slider-init').slick({
        //     dots: false,
        //     infinite: false,
        //     speed: 300,
        //     arrows: false,
        //     slidesToShow: 1,
        //     slidesToScroll: 1,
        //     cssEase: 'linear',
        //     responsive: [
        //         {
        //             breakpoint: 1024,
        //             settings: {
        //                 slidesToShow: 1,
        //                 slidesToScroll: 1,
        //
        //             }
        //         },
        //         {
        //             breakpoint: 540,
        //             settings: "unslick"
        //
        //         }
        //
        //     ]
        // });

        $('.slider-reverse').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            cssEase: 'linear',
            rtl: true,
            prevArrow: '.arrow-prev',
            nextArrow: '.arrow-next',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,

                    }
                },
                {
                    breakpoint: 540,
                    settings: {
                        slidesToShow: 1,
                    }
                }

            ]
        });

        imagesLoaded(document.querySelector('[data-scroll-container]'), { background: true }, function () {
            scroll.update();
        });

        $('#jsMenuTrigger').on('click', function(){
            $(this).parent().toggleClass('active');
            $('body').toggleClass('menu-open');
        })



        // let observer = new IntersectionObserver( (entries, observer) => { entries.forEach(entry => { if(entry.isIntersecting){ entry.target.classList.add('aos-animate'); }else{ entry.target.classList.remove('aos-animate'); } }); }); document.querySelectorAll('[data-aos]').forEach(aosElem => { observer.observe(aosElem) })
    })